export default {
    menu: {
        dashboard: "Dashboard",
        store: "Store",
        profile: "Profile",
        setting: "Setting",
        general: "General",
        news: "News",
        app: "Application",
        tasks: "Tasks",
        contact: "Contact US",
        info: "Info",
        website: "Website",
        "logout": "Logout",
        home: "Home",
        system: "System",
        about: "About",
        "fileExplorer": "File Explorer",
        "shortcut": "Shortcut",
        "persons": "persons",
        "users": "Users",
        "list": "List",
        "add": "Add",
        "roles": "Roles",
        "session": "Session",
        "license": "License"
    },
    eid: {
        fitrTitle: "Eid al-Fitr Mubarak",
        fitrSubtitle: "Blessed Eid al-Fitr",
        fitrMessage: "May Allah accept from us and from you all good deeds",
        adhaTitle: "Eid al-Adha Mubarak",
        adhaSubtitle: "Blessed Eid al-Adha",
        adhaMessage: "May Allah accept from us and from you all good deeds and sacrifices"
    },
    text: {
        "addNewUser": "Add New User",
        "editedUser": "Edited User",
        "addNewRole": "Add New Role",
        edited: "Edited",
        "EditedRole": "Edited Role",
        "roleInfo": "Role Information",
        done: "Done",
        error: "Error Occur",
        areSure: "Are you sure you want to delete Item ",
        confirmation: "Confirmation",
        sureLogout: "Are you sure you want to logout ",
        yes: "Yes",
        no: "No",
        loading: "Loading",
        view: "View"
    },
    signIn: {
        welcome: "Welcome",
        signIn: "Sign in to continue",
        button: "Sign In",
        description: "Secure access to your workspace, plugins, and business data from one place.",
        features: {
            protected: "Protected access",
            fast: "Fast workspace launch",
            unified: "Unified control panel"
        }
    },
    form: {
        email: "Email",
        password: "Password",
        name: "Name",
        username: "Username",
        "id": "ID",
        state: "State",
        path: "url",
        image: "Image",
        "role": "Role",
        description: "Description",
        address: "Address",
        type: "Type",
        version: "Version",
        phone: "Phone",
        subject: "Subject",
        department: "Department",
        message: "Message",
        search: "Search",
        actions: "Actions",
        status: "Status",
        app: "App"
    },
    placeholder: {
        search: "Search files and folders..."
    },
    button: {
        add: "Add",
        delete: "Delete",
        "create": "Create",
        "edited": "Edited",
        close: 'Close',
        "upload": "Upload",
        open: "Open",
        "view": "View",
        save: "Save",
        refresh: "Refresh",
        check: "Check",
        validateToken: "Validate Token",
        license: "License",
        differentLicense: "Different License",
        update: "Update",
        send: "Send",
        more: "Raed More",
        done: "Done",
        edit: "Edit"
    },
    setting: {
        scale: "Scale",
        menu: "Menu Type",
        language: "Language",
        theme: "Theme",
        subtitle: "Customize your experience",
        display: "Display",
        allThemes: "All",
        lightThemes: "Light",
        darkThemes: "Dark"
    },
    store: {
        subtitle: "Browse and manage your plugins",
        features: "Features",
        version: "Version",
        faq: "Faq",
        // View Options & Categories
        view_grid: "Grid View",
        view_table: "Table View",
        all_categories: "All Categories",
        categories: "Categories",
        pricing: "Pricing",
        // Plugin Management
        plugin: "Plugin",
        plugins: "Plugins",
        application: "Application",
        applications: "Applications",
        all_types: "All Types",
        no_products: "No plugins found",
        try_different_search: "Try adjusting your search or filter criteria",
        // Installation Status
        free: "Free",
        requiresLicense: "Requires License",
        proOnly: "Pro / License Required",
        activateLicense: "Activate License",
        licenseRequired: "License Key Required",
        installed: "Installed",
        not_installed: "Not Installed",
        can_install: "Can Install",
        restricted: "Restricted",
        installation_denied: "Installation Denied",
        installation_restricted: "You are not allowed to install this plugin",
        // Plugin States
        running: "Running",
        stopped: "Stopped",
        plugin_running: "Plugin Running",
        plugin_stopped: "Plugin Stopped",
        // Actions
        install_plugin: "Install Plugin",
        update_plugin: "Update Plugin",
        enable_plugin: "Enable Plugin",
        disable_plugin: "Disable Plugin",
        uninstall_plugin: "Uninstall Plugin",
        open_plugin: "Open Plugin",
        // Status Messages
        installing: "Installing Plugin",
        installing_message: "Installing {name}...",
        installed_success: "Plugin Installed",
        installed_message: "{name} has been installed successfully",
        updating: "Updating Plugin",
        updating_message: "Updating {name} to v{version}...",
        updated_success: "Plugin Updated",
        updated_message: "{name} has been updated successfully",
        enabling: "Enabling Plugin",
        enabled_success: "Plugin Enabled",
        enabled_message: "{name} has been enabled",
        disabling: "Disabling Plugin",
        disabled_success: "Plugin Disabled",
        disabled_message: "{name} has been disabled",
        uninstalling: "Uninstalling Plugin",
        uninstalled_success: "Plugin Uninstalled",
        uninstalled_message: "{name} has been uninstalled",
        // Error Messages
        installation_failed: "Installation Failed",
        update_failed: "Update Failed",
        enable_failed: "Enable Failed",
        disable_failed: "Disable Failed",
        uninstall_failed: "Uninstall Failed",
        failed_install: "Failed to install plugin",
        failed_update: "Failed to update plugin",
        failed_enable: "Failed to enable plugin",
        failed_disable: "Failed to disable plugin",
        failed_uninstall: "Failed to uninstall plugin",
        // Confirmation
        confirm_uninstall: "Confirm Uninstall",
        confirm_uninstall_message: "Are you sure you want to uninstall {name}? This action cannot be undone.",
        // Filters and Search
        installation_status: "Installation Status",
        plugin_state: "Plugin State",
        all_plugins: "All Plugins",
        all_states: "All States",
        updates_only: "Updates Only",
        show_all: "Show All",
        // Version and Status
        latest_version: "Latest Version",
        installed_version: "Installed Version",
        update_available: "Update Available",
        up_to_date: "Up to Date",
        allowed_to_install: "Allowed to Install",
        plugin_installed: "Plugin Installed",
        // Details Page
        installation: "Installation",
        runtime: "Runtime",
        updates: "Updates",
        rating: "Rating",
        price: "Price",
        free: "Free",
        learn_more: "Learn More",
        details: "Details"
    },
    404: {
        lost: "Looks like you are lost",
        available: "Requested resource is not available."
    },
    "fileExplorer": {
        "folders": "Folders",
        "files": "Files",
        "rename": "Rename",
        "download": "Download",
        "shortcut": "Shortcut",
        "emptyFolder": "This folder is empty",
        "emptyFolderDescription": "No files or folders found in this location. You can upload files or create new folders to get started.",
        "noPreview": "No preview available",
        "noPreviewDescription": "This file type cannot be previewed. You can download the file to view it.",
        "previewError": "Preview failed",
        "previewErrorDescription": "An error occurred while trying to preview this file. You can still download it.",
        "openWith": "Open with"
    },
    dashboard: {
        emptyState: {
            title: "No Widgets Available",
            description: "Your dashboard is empty. Install plugins to add widgets and customize your experience."
        },
        subtitle: "Overview of your workspace",
        addWidget: "Add Widget",
        editLayout: "Edit Layout",
        allWidgetsAdded: "All available widgets are already on your dashboard!",
        widgetDescription: "Custom plugin widget"
    },
    tasks: {
        emptyState: {
            title: "No Tasks Available",
            description: "No tasks found to run. Install plugins with task functionality to see available tasks."
        }
    },
    contact: {
        title: "Get in Touch",
        subtitle: "We'd love to hear from you. Send us a message and we'll respond as soon as possible.",
        form: {
            title: "Send us a Message",
            send: "Send Message",
            selectDepartment: "Select Department (Optional)",
            requiredFields: "Please fill in all required fields.",
            rateLimited: "Too many requests. Please wait 30 minutes before sending another message."
        },
        departments: {
            support: "Technical Support",
            sales: "Sales & Billing",
            licensing: "Licensing & Activation",
            feedback: "Feedback & Suggestions",
            general: "General Inquiries"
        },
        social: {
            title: "Connect with Us",
            subtitle: "Reach out through your preferred platform",
            email: "Email Us",
            phone: "Call Us",
            telegram: "Telegram Bot",
            whatsapp: "WhatsApp",
            facebook: "Facebook",
            website: "Website",
            linkedin: "LinkedIn",
            instagram: "Instagram"
        }
    },
    news: {
        title: "News & Updates",
        subtitle: "Stay informed with the latest updates",
        loading: "Loading news...",
        noNews: "No news available",
        noNewsMessage: "Check back later for updates",
        readMore: "Read more",
        share: "Share",
        copied: "Copied",
        linkCopied: "Link copied to clipboard",
        loadMore: "Load more"
    },
    license: {
        title: "License Management",
        subtitle: "Manage your Motanamy EA licensing information",
        currentLicense: "Current License",
        status: "Status",
        type: "Type",
        issuedTo: "Issued To",
        validateToken: "Validate Token",
        refreshLicense: "Refresh License",
        validation: "License Validation",
        refresh: "License Refresh",
        refreshed: "License information refreshed",
        downloaded: "License document downloaded successfully",
        validToken: "Token is valid and has been applied successfully",
        invalidToken: "Invalid token. Please check your license key",
        validationError: "Error occurred during validation. Please try again",
        status: {
            active: "Active",
            inactive: "Inactive",
            unauthorized: "Unauthorized",
            expired: "Expired",
            pending: "Pending",
            free: "Free Community Edition"
        },
        statusDesc: {
            active: "Your license is active and fully operational.",
            inactive: "Your license is inactive and needs attention.",
            unauthorized: "Your license is currently unauthorized and requires validation.",
            expired: "Your license has expired. Please renew to continue.",
            pending: "Your license is registered but has not started yet.",
            free: "Running in free edition mode. You can use free plugins or activate a license key to unlock pro features."
        },
        activateKey: "Activate License Key",
        enterSerialPrompt: "Enter your Motanamy serial number to unlock pro plugins and higher limits:",
        activate: "Activate Key",
        activating: "Activating...",
        serialActivated: "License Key activated successfully!",
        invalidSerial: "Invalid license serial number. Please check and try again.",
        freeNotice: "Free Edition Active",
        freeNoticeDesc: "You are using Motanamy EA in Free Community Mode with access to all free plugins.",
        validationTitle: {
            success: "License Validated Successfully",
            fail: "License Validation Failed",
            error: "Validation Error"
        },
        help: {
            title: "License Help",
            description: "Manage your Motanamy EA license and view current status. Contact support if you need assistance with licensing.",
            contactTitle: "Contact Support",
            quickActions: "Quick Actions",
            downloadLicense: "Download License",
            viewTerms: "View Terms & Conditions"
        },
        subscriptionBanner: {
            kicker: "Subscription",
            title: "Manage your subscription from the cloud dashboard",
            description: "Open the Motanamy subscription dashboard to review your plan, billing details, and renewal controls.",
            action: "Open Subscription Dashboard"
        },
        exportLicense: "Export License Info",
        lastVerified: "Last Verified",
        serial: "License Key",
        copy: "Copy",
        copied: "Copied!",
        plan: "Plan",
        devices: "Devices",
        users: "Users",
        roles: "Roles",
        daysLeft: "{n} days remaining",
        lifetime: "Lifetime License",
        features: "Plan Features",
        includedPlugins: "Included Plugins",
        updateAvailable: "Update Available",
        loading: "Loading license info\u2026",
        errorLoad: "Could not load license data",
        noPlugins: "No plugins included in this license",
        usedDevices: "{used} of {max} devices used",
        payType: {
            year: "Yearly",
            month: "Monthly",
            own: "Perpetual"
        }
    },
    common: {
        close: "Close"
    },
    notFound: {
        welcome: "Welcome to Motanamy",
        description: "One Platform, Infinite Possibilities.\nUnlock the Power of Seamless Integration and Innovation.",
        dashboard: "Go to Dashboard",
        title: "Page Not Found",
        message: "Oops! It seems like you're lost. <br> The page you link might be broken or removed.",
        home: "Back to Home",
        back: "Go Back"
    }
}